import Component, { mixins } from 'vue-class-component'

import RouterMixin, { IRouterMixin } from '@/modules/global/utilities/RouterMixin'
import StringMixin, { IStringMixin } from './StringMixin'

export type IUtilitiesMixin = IRouterMixin & IStringMixin

@Component
export default class UtilitiesMixin extends mixins(RouterMixin, StringMixin) implements IUtilitiesMixin {
  
}
